<template>
	<div class="col" gutter="20">
		<Title title="會員詳細資料" />
		<el-button @click="$router.back()" icon="el-icon-back" type="info" align-self="left"></el-button>
		<el-form :model="formData" label-position="right" label-width="150px">
			<el-form-item label="中文全名">{{formData.name}}</el-form-item>
			<el-form-item label="姓名羅馬拼音">{{formData.wade_giles}}</el-form-item>
			<el-form-item label="性別">{{formData.gender}}</el-form-item>
			<el-form-item label="電子郵件">{{formData.email}}</el-form-item>
			<el-form-item label="出生年月日">{{formData.born_date | formatDateTime}}</el-form-item>
			<el-form-item label="手機號碼">{{formData.phone}}</el-form-item>
			<el-form-item label="學校電話（分機）">{{formData.tel}}</el-form-item>
			<el-form-item label="職業">{{formData.jobs | mapJob}}</el-form-item>
			<el-form-item label="工作經歷">
				<table>
					<tr v-for="(job, i) in formData.jobs" :key="i">
						<th>{{job.start_time | formatDate}}</th>
						<td>{{job.type}}
							<ul>
								<li>{{job.department}}</li>
								<li v-if="job.subject">科目：{{job.subject}}</li>
							</ul>
						</td>
					</tr>
				</table>
			</el-form-item>
			<el-form-item label="教職年資">{{formData.jobs | teacherSeniority}}</el-form-item>
			<el-form-item label="介紹人姓名">{{formData.introducer}}</el-form-item>
			<el-form-item label="加入時間">{{formData.create_time | formatDateTime}}</el-form-item>
			<el-form-item label="上次登入時間">{{formData.login_time | formatDateTime}}</el-form-item>
		</el-form>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import ScoreTable from "@/components/backendManage/JudgeStory/ScoreTable";
import { mapState, mapActions } from 'vuex';
import moment from "moment-timezone";

export default {
	components: { Title, ScoreTable },
	data() {
		return {};
	},
	computed: {
		...mapState('manager', ['formData']),
		id() {
			return this.$route.params.id || '';
		},
	},
	filters: {
		formatDateTime(val) {
			return moment(val).tz("Asia/Taipei").format("YYYY-MM-DD, HH:mm");
		},
		formatDate(val) {
			return moment(val).tz("Asia/Taipei").format("YYYY/MM/DD");
		},
		mapJob(jobs = []) {
			const list = jobs.filter(j => j.presently_employed);
			if (list.length > 0) return list.reduce((a, b) => b.start_time > a.start_time ? b : a).type;
			else if (jobs.length > 0) return jobs.reduce((a, b) => b.end_time > a.end_time ? b : a).type;
			else return "無";
		},
		teacherSeniority(arr = []) {
			const timestamp = arr
				.filter(({ type }) => type == "教育工作者")
				.reduce((a, b) => a && a < b.start_time ? a : b.start_time, 0);
			return timestamp
				&& new Date().getFullYear() - new Date(timestamp).getFullYear() + "年"
				|| "無";
		},
	},
	methods: {
		...mapActions('manager', ['getUserInfo']),
	},
	async created() {
		await this.getUserInfo(this.id);
	},
	mounted() { }
};
</script>

<style lang="scss" scoped>
.el-form {
	max-width: 900px;
}

.score {
	position: fixed;
	right: -500px;
	top: 10px;
	transition: all 0.4s ease;

	.score-btn {
		width: 30px;
		height: 130px;
		text-align: center;
	}
}

.score-open {
	right: 0;
}

.picture-dialog {
	.description {
		padding: 15px 50px;
		font-size: 14px;
		font-weight: 500;
		line-height: 1.71;
		color: #000;
	}
}

.image-card {
	.thumb {
		width: 100%;
		padding-top: 70%;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}
	.caption {
		padding: 10px;
	}
}

th,
td {
	padding: 0 0.5em;
	vertical-align: top;
	line-height: 1.5;

	ul {
		margin-top: 0;
		padding-inline-start: 1.5em;
	}
}
</style>